/* FL Boxy — półka boxów (sections/fl-boxy-grid.liquid).
   Karty i chipy renderuje Liquid; tu tylko: filtry po tagach (LUB w grupie, I między grupami),
   liczniki chipów, sortowanie, stan w #hash (np. #smak=slone&sort=najwiecej) i animacja FLIP. */
(() => {
  'use strict';

  if (customElements.get('fl-boxy-grid')) return;

  const ORDER = {
    polecane: (a, b) => a.i - b.i,
    najwiecej: (a, b) => b.n - a.n || a.i - b.i,
    najmniej: (a, b) => a.n - b.n || a.i - b.i,
    'a-z': (a, b) => a.title.localeCompare(b.title, 'pl') || a.i - b.i
  };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const cap = (s) => String(s).charAt(0).toUpperCase() + String(s).slice(1);
  const slugify = (s) => String(s).toLowerCase().replace(/ł/g, 'l').normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  const uniq = (a) => Array.from(new Set(a));
  const fill = (tpl, map) => String(tpl || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? map[k] : m));
  const plural = (n, forms) => {
    const [one, few = one, many = few] = forms;
    const d = n % 10;
    const t = n % 100;
    if (n === 1) return one;
    return d >= 2 && d <= 4 && (t < 12 || t > 14) ? few : many;
  };
  const CLOSE_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';

  class FLBoxyGrid extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; // ponowne podłączenie (np. przesunięcie sekcji w edytorze) — stan zostaje
      this.ready = true;

      const q = (s) => this.querySelector(s);
      this.list = q('.fl-boxy-grid__list');
      if (!this.list) return;

      this.cards = [...this.list.querySelectorAll(':scope > .fl-boxy-card')].map((el, k) => {
        let tags = {};
        try { tags = JSON.parse(el.dataset.tags || '{}') || {}; } catch (e) { tags = {}; }
        const i = Number(el.dataset.index);
        const out = el.dataset.available === 'false' ? 1 : 0;
        return { el, tags, i: Number.isFinite(i) ? i : k, n: Number(el.dataset.n) || 0, title: el.dataset.title || '', out };
      });
      this.groups = [...this.querySelectorAll('.fl-boxy-grid__group')]
        .map((el) => ({ key: el.dataset.group, chips: [...el.querySelectorAll('.fl-boxy-chip')] }))
        .filter((g) => g.key && g.chips.length);
      this.groups.forEach((g) => { g.vals = g.chips.map((c) => c.dataset.v); });

      this.ui = {
        groups: q('.fl-boxy-grid__groups'),
        toggle: q('.fl-boxy-grid__toggle'),
        badge: q('.fl-boxy-grid__fbadge'),
        clear: q('.fl-boxy-grid__clear'),
        count: q('.fl-boxy-grid__count'),
        done: q('.fl-boxy-grid__done'),
        tokens: q('.fl-boxy-grid__tokens'),
        empty: q('.fl-boxy-grid__empty'),
        sort: q('.fl-boxy-grid__sort select')
      };
      this.text = {
        count: this.dataset.countText || '[n] z [total]',
        show: this.dataset.showText || '[n] [box]',
        none: this.dataset.noneText || '',
        clearAll: this.dataset.clearAllText || '',
        remove: this.dataset.removeText || '',
        forms: (this.dataset.boxForms || 'box|boxy|boxów').split('|').map((s) => s.trim())
      };

      this.state = { f: {}, sort: 'polecane' };
      this.groups.forEach((g) => { this.state.f[g.key] = []; });

      this.addEventListener('click', (e) => this.onClick(e));
      if (this.ui.sort) {
        this.ui.sort.addEventListener('change', () => {
          this.state.sort = ORDER[this.ui.sort.value] ? this.ui.sort.value : 'polecane';
          this.update(true);
        });
      }

      this.readHash();
      if (this.ui.sort) this.ui.sort.value = this.state.sort;
      this.update(false, true);
    }

    onClick(e) {
      const t = e.target;
      if (!t || !t.closest) return;
      const chip = t.closest('.fl-boxy-chip');
      if (chip && this.contains(chip)) {
        if (chip.getAttribute('aria-disabled') === 'true') return;
        const group = chip.closest('.fl-boxy-grid__group');
        this.toggleValue(group && group.dataset.group, chip.dataset.v);
        this.update(true);
        return;
      }
      if (t.closest('[data-clear-filters]')) {
        this.clearAll();
        return;
      }
      const token = t.closest('.fl-boxy-grid__token');
      if (token) {
        this.toggleValue(token.dataset.f, token.dataset.v);
        this.update(true);
        return;
      }
      if (this.ui.toggle && t.closest('.fl-boxy-grid__toggle')) {
        const open = this.ui.toggle.getAttribute('aria-expanded') !== 'true';
        this.ui.toggle.setAttribute('aria-expanded', String(open));
        if (this.ui.groups) this.ui.groups.classList.toggle('is-open', open);
        return;
      }
      if (this.ui.done && t.closest('.fl-boxy-grid__done')) {
        if (this.ui.toggle) this.ui.toggle.setAttribute('aria-expanded', 'false');
        if (this.ui.groups) this.ui.groups.classList.remove('is-open');
        this.list.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    valuesOf(card, key) {
      const v = card.tags[key];
      return Array.isArray(v) ? v : [];
    }

    passes(card, except) {
      return this.groups.every((g) => {
        const on = this.state.f[g.key];
        return g.key === except || !on.length || this.valuesOf(card, g.key).some((v) => on.includes(v));
      });
    }

    activeCount() {
      return this.groups.reduce((a, g) => a + this.state.f[g.key].length, 0);
    }

    toggleValue(key, v) {
      const arr = this.state.f[key];
      if (!arr || v == null) return;
      const at = arr.indexOf(v);
      if (at > -1) arr.splice(at, 1);
      else arr.push(v);
    }

    clearAll() {
      this.groups.forEach((g) => { this.state.f[g.key] = []; });
      this.update(true);
    }

    update(animate, initial) {
      this.renderFilters();
      this.renderGrid(animate);
      this.renderTokens();
      if (!initial) this.writeHash();
    }

    renderFilters() {
      this.groups.forEach((g) => {
        g.chips.forEach((chip) => {
          const v = chip.dataset.v;
          const on = this.state.f[g.key].includes(v);
          const n = this.cards.filter((c) => this.passes(c, g.key) && this.valuesOf(c, g.key).includes(v)).length;
          chip.setAttribute('aria-pressed', String(on));
          chip.setAttribute('aria-label', `${cap(v)}: ${n} ${plural(n, this.text.forms)}`);
          const nEl = chip.querySelector('.fl-boxy-chip__n');
          if (nEl) nEl.textContent = String(n);
          if (!on && n === 0) chip.setAttribute('aria-disabled', 'true');
          else chip.removeAttribute('aria-disabled');
        });
      });
      const a = this.activeCount();
      if (this.ui.clear) this.ui.clear.disabled = a === 0;
      if (this.ui.badge) {
        this.ui.badge.hidden = a === 0;
        this.ui.badge.textContent = String(a);
      }
    }

    // Animacja FLIP: karty przesuwają się na nowe miejsca, nowo widoczne wskakują.
    renderGrid(animate) {
      // Wyprzedane zawsze na końcu; wybrane sortowanie działa w obrębie dostępnych i wyprzedanych.
      const by = ORDER[this.state.sort] || ORDER.polecane;
      const order = this.cards.slice().sort((a, b) => a.out - b.out || by(a, b));
      const visible = new Set(order.filter((c) => this.passes(c)));
      const before = new Map();
      if (animate) this.cards.forEach((c) => { if (!c.el.hidden) before.set(c, c.el.getBoundingClientRect()); });
      const want = order.map((c) => c.i).join();
      const cur = [...this.list.querySelectorAll(':scope > .fl-boxy-card')].map((el) => this.cards.find((c) => c.el === el)?.i).join();
      if (want !== cur) order.forEach((c) => this.list.appendChild(c.el));
      this.cards.forEach((c) => { c.el.hidden = !visible.has(c); });
      if (animate && typeof this.list.animate === 'function') {
        this.cards.forEach((c) => {
          if (c.el.hidden) return;
          const f = before.get(c);
          const l = c.el.getBoundingClientRect();
          if (f) {
            const dx = f.left - l.left;
            const dy = f.top - l.top;
            if (Math.abs(dx) > 1 || Math.abs(dy) > 1) {
              c.el.animate([{ transform: `translate(${dx}px,${dy}px)` }, { transform: 'none' }], { duration: 520, easing: 'cubic-bezier(.2,.8,.2,1)' });
            }
          } else {
            c.el.animate([{ opacity: 0, transform: 'translateY(18px) scale(.96)' }, { opacity: 1, transform: 'none' }], { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1)' });
          }
        });
      }
      const n = visible.size;
      const total = this.cards.length;
      if (this.ui.count) this.ui.count.textContent = fill(this.text.count, { n, total });
      if (this.ui.done) this.ui.done.textContent = n ? fill(this.text.show, { n, box: plural(n, this.text.forms) }) : this.text.none;
      if (this.ui.empty) this.ui.empty.hidden = n > 0;
    }

    renderTokens() {
      const box = this.ui.tokens;
      if (!box) return;
      const list = this.groups.flatMap((g) => this.state.f[g.key].map((v) => ({ g: g.key, v })));
      box.hidden = !list.length;
      box.innerHTML = list.map((t) => `<button type="button" class="fl-boxy-grid__token" data-f="${esc(t.g)}" data-v="${esc(t.v)}" aria-label="${esc(`${this.text.remove} ${t.v}`.trim())}">${esc(cap(t.v))}${CLOSE_ICON}</button>`).join('')
        + (list.length > 1 && this.text.clearAll ? `<button type="button" class="fl-boxy-grid__token fl-boxy-grid__token--clear" data-clear-filters>${esc(this.text.clearAll)}</button>` : '');
    }

    writeHash() {
      const parts = [];
      this.groups.forEach((g) => {
        const on = this.state.f[g.key];
        if (on.length) parts.push(`${g.key}=${on.map(slugify).join(',')}`);
      });
      if (this.state.sort !== 'polecane') parts.push(`sort=${this.state.sort}`);
      try {
        history.replaceState(history.state, '', location.pathname + location.search + (parts.length ? `#${parts.join('&')}` : ''));
      } catch (e) { /* np. ograniczenia ramki edytora */ }
    }

    readHash() {
      let h = '';
      try { h = decodeURIComponent(location.hash.slice(1)); } catch (e) { return; }
      if (!h.includes('=')) return;
      h.split('&').forEach((kv) => {
        const [k, v] = kv.split('=');
        if (k === 'sort' && ORDER[v]) this.state.sort = v;
        const g = this.groups.find((x) => x.key === k);
        if (g && v) this.state.f[k] = uniq(v.split(',').map((s) => g.vals.find((val) => slugify(val) === s)).filter(Boolean));
      });
    }
  }

  customElements.define('fl-boxy-grid', FLBoxyGrid);
})();
